export function strToInt(str: string) {
  try {
    const parsed = parseInt(str);
    return parsed;
  } catch {
    return undefined;
  }
}

export function intToStr(n: number, numDigits: number): string {
  return n.toLocaleString('en-US', {
    minimumIntegerDigits: numDigits,
    maximumFractionDigits: 0,
    useGrouping: false,
  });
}

export function intToOneDigitStr(n: number) {
  return n < 10 ? n.toString() : `9+`;
}
